import { TRAFFIC_COLORS } from '../constants';

/**
 * Threshold values for traffic (AADT) ranges
 * IMPORTANT: These values build MapLayersService's TRAFFIC_AADT_LINE_COLOR
 * If you change these, update the Mapbox interpolation expression accordingly
 */
export const TRAFFIC_THRESHOLDS = {
  RANGE_0_1000: 0,
  RANGE_1000_8000: 1000,
  RANGE_8000_15000: 8000,
  RANGE_15000_44000: 15000,
  RANGE_44000_PLUS: 44000,
} as const;

/**
 * Get the traffic line color based on AADT (Average Annual Daily Traffic)
 * Matches MapLayersService's TRAFFIC_AADT_LINE_COLOR interpolation
 */
export function getTrafficByAADT(aadt: number | undefined): { color: string; label: string } {
  const traffic = aadt ?? 0;

  if (traffic >= TRAFFIC_THRESHOLDS.RANGE_44000_PLUS) return TRAFFIC_COLORS.RANGE_44000_PLUS;
  if (traffic >= TRAFFIC_THRESHOLDS.RANGE_15000_44000) return TRAFFIC_COLORS.RANGE_15000_44000;
  if (traffic >= TRAFFIC_THRESHOLDS.RANGE_8000_15000) return TRAFFIC_COLORS.RANGE_8000_15000;
  if (traffic >= TRAFFIC_THRESHOLDS.RANGE_1000_8000) return TRAFFIC_COLORS.RANGE_1000_8000;

  return TRAFFIC_COLORS.RANGE_0_1000;
}
